import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function FocusNarrative() {
  const focusArticles = articles.slice(0, 2);

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto px-4 md:px-6 max-w-[1440px]">
        <div className="flex flex-col lg:flex-row gap-0 lg:gap-0">
          <div className="w-full lg:w-[60%] flex flex-col justify-center lg:pr-20">
            <span className="text-xs font-medium text-foreground-500 uppercase tracking-wider mb-6">
              今日焦点
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-snug lg:max-w-lg">
              深度追踪娱乐江湖的风云变幻，不错过任何一个重磅
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mt-8 leading-relaxed max-w-md">
              每天精选最值得关注的娱乐事件，为你提供多角度、全方位的深度报道与独到分析。黑料入口团队全天候追踪一手资讯，确保你比99%的人更早知道真相。
            </p>
            <Link
              to={`/article/${focusArticles[0]?.slug || '#'}`}
              className="inline-flex items-center gap-2 mt-8 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
            >
              阅读今日焦点
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="w-full lg:w-[40%] mt-10 lg:mt-0">
            <div className="w-full h-[250px] md:h-[320px] overflow-hidden rounded-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Paparazzi%20style%20street%20photography%20of%20celebrities%20walking%20through%20urban%20alley%20at%20golden%20hour%2C%20warm%20backlight%20creating%20dramatic%20silhouettes%2C%20candid%20documentary%20style%2C%20cinematic%20color%20grading%20with%20muted%20tones%2C%20shallow%20depth%20of%20field%2C%20nostalgic%20film%20grain%20texture%2C%20warm%20amber%20and%20soft%20shadow%20palette&width=800&height=500&seq=focus-narrative-01&orientation=landscape"
                alt="今日焦点 - 黑料入口"
                title="黑料入口 - 今日焦点深度追踪"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}